// extracted by mini-css-extract-plugin
export var chevron = "_mt-2";
export var chevronRotated = "_mt-3";
export var header = "_mt-1";
export var section = "_mt-0";